<template>
	<div v-if="loading" class="page-content">
		<Loading />
	</div>

	<app-header
		:app="appData.app"
		:developer="appData.developer"
		:platformType="appData.platformType"
	/>
	<tab-view
		:app-data="appData"
		:defaultTab="defaultTab"
    :isHistory="false"
	/>

	<NotificationComponent
		v-if="notification.show"
		:key="notification.key"
		:type="notification.type"
		:title="notification.title"
		:message="notification.message"
		@closed="!notification.show"
	/>
</template>

<script>
import { storeImage } from "@/ultis/user/functions/storePlatform";
import NotificationComponent from "@/components/custom/notifications/NotificationComponent.vue";
import Modal from "@/components/custom/modals/ModalComponent.vue";
import Loading from "@/components/user/layout/LoadingComponent.vue";
import AppHeader from "@/components/user/viewComponent/app/tabs/AppHeader.vue";
import TabView from "@/components/user/viewComponent/app/tabs/TabView.vue";
import clickOutside from "@/ultis/user/functions/click-outside";

export default {
	name: "HistoryInfo",
	components: {
		NotificationComponent,
		Modal,
		Loading,
		AppHeader,
		TabView,
	},
	directives: {
		clickOutside,
	},
	props: {
		appData: {
			type: Object,
			required: true,
		},
		defaultTab: {
			type: String,
			required: false,
		},
	},
	data() {
		return {
			notification: {
				show: false,
				key: 0,
				type: "",
				title: "",
				message: "",
			},
			appData: this.appData,
			loading: false,
		};
	},
	methods: {
		getStoreImage(platformTypeId) {
			return storeImage(platformTypeId);
		},
		
		showNotification(type, title, message) {
			this.notification = {
				show: true,
				key: Date.now(),
				type,
				title,
				message,
			};
		},
	},
};
</script>

<style scoped>
.app-info {
	position: relative;
	width: 100%;
}

.back-button {
	display: flex;
	align-items: center;
	gap: 8px;
	cursor: pointer;
	padding: 10px;
	background: white;
	border-radius: 8px;
	box-shadow: 0 0 5px #9e9e9e;
	margin-bottom: 10px;
	font-size: 14px;
}

.back-button .material-icons-outlined {
	font-size: 18px;
	color: #333;
}

.back-button .text {
	font-weight: 500;
	color: #333;
}

.tracking-history {
	padding: 6px;
	max-height: 70vh;
	overflow-y: auto;
}

.tracking-history::-webkit-scrollbar {
	width: 6px;
}

.tracking-history::-webkit-scrollbar-thumb {
	background-color: #cbd5e0;
	border-radius: 3px;
}

.tracking-history::-webkit-scrollbar-track {
	background-color: #f1f1f1;
}

.properties-strip {
	display: flex;
	flex-direction: column;
	align-items: flex-end;
	padding: 10px;
}

.material-icons-outlined {
	font-size: 15px;
}

/* Currency Switcher CSS */
.currency-switcher {
	position: relative;
	margin: 0 auto;
	width: 268px;
}
.flag {
	width: 25px;
}

div.dropdown {
	position: relative;
	width: 190px;
}

div.dropdown:after {
	content: "";
	position: absolute;
	margin: 0;
	width: 16px;
	height: 17px;
	background-image: url(http://botkits.ru/img/icons/down.svg);
	top: 15px;
	right: 10px;
	-webkit-transition: 0.3s;
	transition: 0.3s;
}

div.dropdown.open:after {
	-webkit-transform: rotate(180deg);
	transform: rotate(180deg);
}

div.dropdown > div.caption {
	background: #ffffff;
	border-radius: 8px;
	cursor: pointer;
	user-select: none;
	padding: 9px 13px 9px 45px;
	font-size: 13px;
	line-height: 150%;
	letter-spacing: 0.3px;
	box-shadow: 0 0 5px #9e9e9e;
}

div.dropdown > div.list {
	position: absolute;
	background-color: #fff;
	width: 100%;
	top: 42px;
	border-radius: 8px;
	padding: 10px 0;
	opacity: 0;
	visibility: hidden;
	overflow: hidden;
	overflow-y: auto;
	max-height: 300px;
	box-shadow: 0px 12px 24px rgba(21, 18, 51, 0.13);
	transform: scale(0.85);
	transform-origin: 50% 0;
	transition: all 0.15s cubic-bezier(0.25, 0, 0.25, 1.75), opacity 0.1s linear;
	-webkit-transition: all 0.15s cubic-bezier(0.25, 0, 0.25, 1.75),
		opacity 0.1s linear;
	-webkit-box-shadow: 0px 12px 24px rgba(21, 18, 51, 0.13);
	-webkit-transform: scale(0.85);
	-webkit-transform-origin: 50% 0;
	z-index: -1;
}

div.dropdown > div.list::-webkit-scrollbar {
	width: 4px;
	cursor: pointer;
}

div.dropdown > div.list::-webkit-scrollbar-thumb {
	background-color: var(--logo-color);
	border-radius: 4px;
	cursor: pointer;
}

div.dropdown > div.list::-webkit-scrollbar-thumb:hover {
	background-color: var(--logo-hover-color);
	cursor: pointer;
}

div.dropdown.open > div.list {
	-webkit-transform: scale(1);
	transform: scale(1);
	opacity: 1;
	z-index: 1;
	visibility: visible;
}

div.dropdown > div.list > div.item {
	padding: 8.5px 15px 8.5px 50px;
	cursor: pointer;
	-webkit-transition: 0.3s;
	transition: 0.3s;
	font-size: 14px;
	line-height: 150%;
	letter-spacing: 0.3px;
}

.div.dropdown > div.list > div.item .name {
	font-size: 13px;
	letter-spacing: 0.3px;
	user-select: none;
	font-weight: 400;
}

div.dropdown > div.list > div.item.selected {
	background: rgba(36, 60, 187, 0.2);
	pointer-events: none;
}

div.dropdown > div.list > div.item:hover {
	background: #f8f9fb;
}

div.dropdown > div.caption img,
div.dropdown > div.list > div.item img,
div.dropdown > div.caption svg,
div.dropdown > div.list > div.item svg {
	position: absolute;
	margin-top: 2.5px;
	left: 15px;
}

div.dropdown > div.list > div.item .short-name,
div.dropdown > div.caption span {
	font-weight: 600;
	font-size: 10px;
	letter-spacing: 0.3px;
	color: var(--logo-color);
	position: absolute;
	right: 20px;
}

div.dropdown > div.list > div.item .short-name {
	right: 12px;
}
div.dropdown > div.caption .list-icon {
	font-size: 18px;
	font-weight: 400;
	line-height: 1;
	color: var(--logo-color);
	transition: transform 0.2s ease;
}

/* List Menu Styles */
.list-menu {
	margin-top: 10px;
	background: white;
	border-radius: 10px;
	box-shadow: 0 0 5px #9e9e9e;
	padding: 10px;
	max-width: 300px;
	width: 100%;
}

.checkbox-item {
	display: flex;
	align-items: center;
	margin-bottom: 0px;
	padding: 0px 15px;
}

.checkbox-item input[type="checkbox"] {
	appearance: none;
	width: 16px;
	height: 16px;
	border: 1px solid #bdbdbd;
	border-radius: 4px;
	display: inline-block;
	margin-right: 5px;
	cursor: pointer;
	position: relative;
	transition: all 0.3s ease;
	background-color: white;
}

.checkbox-item input[type="checkbox"]:hover,
.checkbox-item:hover input[type="checkbox"] {
	border-color: var(--logo-color);
	box-shadow: 0 0 5px rgba(243, 177, 33, 0.4);
}

.checkbox-item input[type="checkbox"]:checked {
	border-color: var(--logo-color);
	background-color: var(--logo-color);
}

.checkbox-item input[type="checkbox"]:checked::after {
	content: "\2713";
	font-size: 14px;
	color: white;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
}

.checkbox-item label {
	font-size: 14px;
	margin-left: 2px;
	color: #333;
	cursor: pointer;
	user-select: none;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	max-width: calc(100% - 40px);
}

.checkbox-item:hover {
	cursor: pointer;
}

.list-item {
	display: flex;
	align-items: center;
	min-width: 100%;
	padding: 8px 0px;
	margin-bottom: 5px;
	transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
@media (max-width: 855px) {
	div.dropdown {
		position: relative;
		width: 100%;
	}
}
</style>
